import {Component, inject, OnDestroy, OnInit, ChangeDetectionStrategy} from '@angular/core';
import {RouterLink} from '@angular/router';
import {AuthService} from '../../../auth/services/auth-service';
import {AsyncPipe} from '@angular/common';
import {ProfileService} from '../../../users/services/profile-service';
import {UserProfileDto} from '../../../users/dto/UserProfileDto';
import {distinctUntilChanged, filter, Observable, Subscription, switchMap} from 'rxjs';

@Component({
  selector: 'app-header-component',
  imports: [
    RouterLink,
    AsyncPipe
  ],
  templateUrl: './header-component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './header-component.scss'
})
export class HeaderComponent implements OnInit, OnDestroy {

  protected authService: AuthService = inject(AuthService);
  protected profileService = inject(ProfileService);

  protected profile: UserProfileDto | undefined;
  protected isAuthenticated$!: Observable<boolean>;
  private subscription: Subscription | null = null;

  ngOnInit(): void {
    this.isAuthenticated$ = this.authService.isAuthenticated();
    this.subscription = this.isAuthenticated$
      .pipe(
        distinctUntilChanged(),
        filter(value => value),
        switchMap(() => this.profileService.getCurrentProfile())
      )
      .subscribe(result => {
        if (result.data) {
          this.profile = result.data;
        }
    });
  }

  ngOnDestroy() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

}
